var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[(_vm.content === true)?_c('div',[_c('i',{staticClass:"fa fa-check"})]):_c('i')])
}
var staticRenderFns = []

export { render, staticRenderFns }